import Vue from "vue";
export const sum = (v) => `${v || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

Vue.prototype.$sum = sum;

Vue.filter("sum", sum);

// Amounts with comma thousands separators: 16335000 -> 16,335,000 (keeps a decimal part and a minus sign).
export const comma = (v) => {
  const [int, dec] = `${v ?? 0}`.split(".");
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (dec ? `.${dec}` : "");
};

Vue.prototype.$comma = comma;

Vue.filter("comma", comma);
